module.exports = __webpack_public_path__ + "img/info.9d625895.svg";